export default __webpack_public_path__ + "static/media/image1.d4624b20.png";